import { cn } from "~/common/cn"
import { StarDecoration } from "../star-decoration"
import { HeaderImage } from "./header-image"

// Constant for star positions and sizes
const STAR_DECORATIONS = [
  { position: "right-[0%] top-[-16px] md:right-[10%] md:top-[55%] block", size: 44 },
  { position: "left-[0%] top-[32px] md:left-[10%] md:top-[15%] block", size: 44 },
  { position: "bottom-[20%] left-[5%] hidden md:block", size: 36 },
]

export function GroupedStars() {
  return (
    <div>
      <div className="relative md:mb-[-64px] md:mr-[-32px] lg:mr-[-64px]">
        <HeaderImage />

        {STAR_DECORATIONS.map((star, index) => (
          <div key={index} className={cn("absolute", star.position)}>
            <StarDecoration width={star.size} height={star.size} />
          </div>
        ))}
      </div>
    </div>
  )
}
